import { EntityRequest } from "../entity/EntityRequest";
import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoRequestCarusesGetRes } from "./abst/DtoRequestCarusesGetRes";

export class DtoRequestCarusesGetResImple extends DtoRequestCarusesGetRes {
  public request = new EntityRequest();

  public pager = new DtoApiPager();
}
